document.addEventListener('DOMContentLoaded', function () {
  let klaviyoSyncIntervalId = null;
  let klaviyoSyncStopTimeoutId = null;

  const getBackInStockTriggers = function () {
    return document.querySelectorAll('.klaviyo-bis-trigger');
  };

  const isVisibleButton = function (button) {
    if (!button) return false;
    const style = window.getComputedStyle(button);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    const rect = button.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  };

  const getMainProductButtons = function () {
    return Array.from(document.querySelectorAll('.product-form__add-button[data-product-add-to-cart-button]')).filter(
      function (button) {
        return !button.closest('.product-sticky-form');
      }
    );
  };

  const canPurchaseCurrentSelection = function () {
    const buttons = getMainProductButtons();
    if (!buttons.length) return null;

    const visibleButtons = buttons.filter(isVisibleButton);
    const sourceButtons = visibleButtons.length ? visibleButtons : buttons;

    return sourceButtons.some(function (button) {
      return !button.hasAttribute('disabled');
    });
  };

  const syncBackInStockTrigger = function () {
    const triggers = getBackInStockTriggers();
    if (!triggers.length) return;

    // Configurator/DIY templates should never show Klaviyo BIS trigger.
    const isConfiguratorTemplate =
      !!document.querySelector('#AddToCartCustom') ||
      !!document.querySelector('.configurator-button.product-form__add-button');
    if (isConfiguratorTemplate) {
      triggers.forEach(function (trigger) {
        trigger.style.setProperty('display', 'none', 'important');
        trigger.setAttribute('aria-hidden', 'true');
      });
      return;
    }

    const canPurchase = canPurchaseCurrentSelection();

    triggers.forEach(function (trigger) {
      if (canPurchase === true) {
        trigger.style.setProperty('display', 'none', 'important');
        trigger.setAttribute('aria-hidden', 'true');
      } else if (canPurchase === false) {
        trigger.style.setProperty('display', 'inline-block', 'important');
        trigger.setAttribute('aria-hidden', 'false');
      }
      // If canPurchase is null (state not yet resolved), keep current state.
    });
  };

  const queuedSync = function () {
    window.requestAnimationFrame(syncBackInStockTrigger);
  };

  document.addEventListener('variant:changed', queuedSync);
  document.addEventListener('shopify:section:load', queuedSync);
  document.addEventListener('shopify:section:reorder', queuedSync);
  document.addEventListener('shopify:section:select', queuedSync);
  window.addEventListener('resize', queuedSync);
  window.addEventListener('load', queuedSync);

  const observer = new MutationObserver(queuedSync);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'disabled'],
  });

  syncBackInStockTrigger();
  setTimeout(syncBackInStockTrigger, 2500);
  setTimeout(syncBackInStockTrigger, 5000);
  setTimeout(syncBackInStockTrigger, 8000);

  // Klaviyo can inject or re-style the trigger late on Safari.
  // Keep syncing for a short window to enforce final state.
  klaviyoSyncIntervalId = window.setInterval(syncBackInStockTrigger, 400);
  klaviyoSyncStopTimeoutId = window.setTimeout(function () {
    if (klaviyoSyncIntervalId) {
      window.clearInterval(klaviyoSyncIntervalId);
      klaviyoSyncIntervalId = null;
    }
    if (klaviyoSyncStopTimeoutId) {
      window.clearTimeout(klaviyoSyncStopTimeoutId);
      klaviyoSyncStopTimeoutId = null;
    }
  }, 20000);
});

// const formOptionSelectorLength = document.querySelectorAll('.product-form__option-selector').length;

// if (formOptionSelectorLength > 1) {
//   document.querySelectorAll('.product-form__option-selector input[type="radio"]').forEach( inputElement => {
//     inputElement.addEventListener( 'change', () => {
//       if (inputElement.name !== `option${formOptionSelectorLength}`) {

//         const optionSelectorArray = [...document.querySelectorAll('.product-form__option-selector input[type="radio"]:checked')];

//         const optionSelectedArray = optionSelectorArray.map( optionSelectedItem => {
//           if (optionSelectedItem.name !== `option${formOptionSelectorLength}`) {
//             return optionSelectedItem.value;
//           }
//         });

//         document.querySelectorAll(`.product-form__option-selector input[name="option${formOptionSelectorLength}"]`).forEach( inputLastElement => {
//           optionSelectedArray[optionSelectedArray.length - 1] = inputLastElement.value;
//           const variantTitle = optionSelectedArray.join(' / ');
          
//           const inputLabel = inputLastElement.parentElement.querySelector('label');
//           const discountLabelSelector = inputLastElement.parentElement.querySelector('.block-swatch__discount-label');
//           const discountSVG = '<svg xmlns="http://www.w3.org/2000/svg" width="46" height="23" viewBox="0 0 46 23" fill="none"><path d="M1.82178 0L46 3.91L40.3069 13.11L44.1782 23L0 18.86L5.69307 9.66L1.82178 0Z" fill="#35907E"></path></svg>';
          
//           if (discountLabelSelector) discountLabelSelector.remove();
          
//           variants.forEach( variant => {
//             if (variant.available && variant.title == variantTitle && variant.compare_at_price > variant.price) {
//               console.log(variant.available);
//               const discount = Math.round((((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price));
//               const discountHTML = `<span class="block-swatch__discount-label">${discountSVG}<span style="color: #F6ECEC">${discount}%</span></span>`;
              
//               inputLabel.innerHTML = inputLabel.innerHTML + discountHTML;
//             }
//           });
//         });
//       }
//     });
//   });
// }

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    // Select the element with class 'product-media product__media'
    var mediaElement = document.querySelector('.Product-banner-custom');
    // Check if the element has the 'became-visible' class
    if (mediaElement && mediaElement.classList.contains('ed-product')) {
      // Find the div inside and make it visible (e.g., block)
      var product_media = mediaElement.querySelector('.product__media');
      if (product_media) {
        product_media.style.display = 'block'; // Change display to block to show it
      }
    }
  }, 80); // Delay in milliseconds (2000ms = 2 seconds)
});

// document.addEventListener('DOMContentLoaded', function () {
//   setTimeout(function () {
//     var mediaElement = document.querySelector('.Product-banner-custom');

//     if (mediaElement && mediaElement.classList.contains('ed-product')) {
//       var product_media = mediaElement.querySelector('.product__media');

//       if (product_media) {
//         product_media.style.opacity = '0'; // Start with opacity 0
//         product_media.style.visibility = 'hidden'; // Hide it initially
//         product_media.style.display = 'block'; // Make it occupy space

//         // Smooth transition effect
//         setTimeout(() => {
//           product_media.style.transition = 'opacity 0.5s ease-in-out, visibility 0.5s ease-in-out';
//           product_media.style.opacity = '1';
//           product_media.style.visibility = 'visible';
//         }, 10); // Small delay to allow display change before transition
//       }
//     }
//   }, 150);
// });



  // Select all video thumbnails with SVGs
  // var videoThumbnails = document.querySelectorAll('.video-thumbnail svg');
  
  // // Add click event listener to each SVG
  // videoThumbnails.forEach(function(svg) {
  //   svg.addEventListener('click', function() {
  //     // Trigger click on the second page dot (index 1)
  //     var secondDot = document.querySelectorAll('.flickity-page-dots li')[1];
  //     if (secondDot) {
  //       // Get all elements with the class 'video__play-button'
  //         var videos = document.getElementsByClassName("video__play-button");
  //         // Loop through all the elements and trigger a click on each
  //         for (var i = 0; i < videos.length; i++) {
  //           videos[i].click();
  //         }
  //       secondDot.click();
  //     }
  //   });
  // }); 


  // Select all video thumbnails with SVGs
  // Today commented code
  var videoThumbnails = document.querySelectorAll('.video-thumbnail svg');
  // Add click event listener to each SVG
  videoThumbnails.forEach(function(svg) {
    svg.addEventListener('click', function() {
    let videoIndexes = [];
      $('.flickity-slider .product__media-item').each(function(index) {
        if ($(this).find('.video_container').length) {
           videoIndexes.push(index);
        }
      });
      console.log('videoIndexes'+videoIndexes); 
      // Trigger click on the second page dot (index 1)
      var secondDot = document.querySelectorAll('.flickity-page-dots li')[videoIndexes]; 
      if (secondDot) {
        // Get all elements with the class 'video__play-button'
          var videos = document.getElementsByClassName("video__play-button");
          // Loop through all the elements and trigger a click on each
          for (var i = 0; i < videos.length; i++) {
            videos[i].click();
          }
        secondDot.click();
      }
    });
  });


var videoThumbnails = document.querySelectorAll('.video-thumbnail svg');

videoThumbnails.forEach(function(svg, thumbIndex) {
  svg.addEventListener('click', function() {
    let videoIndexes = [];

    // Find indexes of product__media-item that contain video_container
    document.querySelectorAll('.flickity-slider .product__media-item').forEach(function(item, index) {
      if (item.querySelector('.video_container')) {
        videoIndexes.push(index);
      }
    });
 
      console.log('videoIndexes:', videoIndexes);
      console.log('thumbIndex---'+thumbIndex);
    // Click the page dot that matches the *video container* position for this thumbnail
    let matchingDotIndex = videoIndexes[thumbIndex]; // thumbIndex maps to videoIndexes position
    console.log(matchingDotIndex);
    if (typeof matchingDotIndex !== 'undefined') {
      let allDots = document.querySelectorAll('.flickity-page-dots li');
      let targetDot = allDots[matchingDotIndex];
       console.log('target-dot'+targetDot);
      if (targetDot) {
        //alert('targetDot'+targetDot);
        // Optional: play videos
        document.querySelectorAll('.video__play-button').forEach(function(btn) {
          btn.click();
        });
        console.log('target-dot'+targetDot);
        // Trigger flickity dot click
        targetDot.click();
      }
    }
  });
});




  function CustomAddToCart(element) {
      var total_properties_needed = 0;
      var total_addon_price = 0;
      $(".all_total_values_count").each(function(){
          console.log($(this).val());
          var dataprice = parseFloat($(this).attr('data-price')) || 0;
          if ($(this).val() > 0) {
            total_properties_needed = parseInt(total_properties_needed) + parseInt($(this).val());
            if (dataprice > 0) {
              // ✅ Metafield se aaya hua actual price use ho raha hai
              total_addon_price = parseFloat(total_addon_price) + dataprice;
            }
          }
      });
      //alert(total_properties_needed+'needed properties');
      console.log("total_properties_needed", total_properties_needed);
      $(".custom_properties").html('');
      var total_values_added = 0;
      $(".items").each(function(){
        //if ($(this).hasClass('No-engraving') == false) {
          if ($(this).hasClass('active')) {
            var propertyname = $(this).attr('data-property-name');
            var propertyvalue = $(this).attr('data-property-value');
            const inputElement = $('<input>', {
                type: 'hidden',
                name: `properties[${propertyname}]`,
                value: propertyvalue
            });
            total_values_added = parseInt(total_values_added)+parseInt(1);
            // Append the input element to the specified class
            $(`.custom_properties`).append(inputElement);
            console.log("This .items element has the active class:", this);
          }
        //}
      });
    console.log('show data');
    console.log($(".custom_properties").html());
    
      $(".motive_text").each(function(){
        if ($(this).val() != '') {
          var propertyname = $(this).attr('data-property-name') || $(this).attr('data-attr-name');
          //var propertyvalue = $(this).val();
          var propertyvalue = $(this).val().replace(/\n/g, '<br>');
          console.log('propertyname---'+propertyname);
          if(propertyname != undefined && propertyname !== '') { 
          const inputElement = $('<input>', {
              type: 'hidden',
              name: `properties[${propertyname}]`,
              value: propertyvalue
          });
          total_values_added = parseInt(total_values_added)+parseInt(1);
          $(`.custom_properties`).append(inputElement);
          }
        }
      });

      $('.file_upload').each(function (index, element) {
        if ($(element).attr('type') === 'file') { // Check if the element is of type 'file'
          const fileInput = $(element)[0]; // Get the DOM element
          const files = fileInput.files; // Get the FileList object

          if (files.length > 0) {
            total_values_added = parseInt(total_values_added)+parseInt(1);
            /*const file = files[0]; // Get the first file
            console.log(`File ${index + 1}:`);
            console.log('Name:', file.name);
            console.log('Size:', file.size);
            console.log('Type:', file.type);*/
          }
        }
      });

      // Send Addon Price
      /*if ($(".selected_customisable_product").length > 0) {
        if ($(".selected_customisable_product").attr('data-product-price') > 0) {
          const inputElement = $('<input>', {
              type: 'hidden',
              name: `properties[Related Product]`,
              value: $(".selected_customisable_product").attr('data-product-name')
          });
          $(`.custom_properties`).append(inputElement);
          var related_product_price = parseInt($(".selected_customisable_product").attr('data-product-price'))/100;
          total_addon_price = parseFloat(total_addon_price)+parseFloat(related_product_price)
        }
      }*/
      if (total_addon_price > 0) {
        const inputElement = $('<input>', {
            type: 'hidden',
            name: `properties[_Total Addon Price]`,
            value: total_addon_price
        });
        $(`.custom_properties`).append(inputElement);
      }

       //console.log('^^^^^^^^^^^^^'+total_values_added);
       console.log("Test", parseInt(total_properties_needed),parseInt(total_values_added) );
      if (parseInt(total_properties_needed) == parseInt(total_values_added)) {
       // alert('ffff')
         //$('form.shopify-product-form').submit();
        var variationid = $(".selected_customisable_product").attr('data-variation-id');
       // alert('^^^^^'+variationid+'>>>>>>>>>>');
        //return false;
        if ($(".selected_customisable_product").length > 0 && variationid) {
          var items = [];
          items.push({id : variationid , quantity : 1});
          var data = {items};
          $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: data,
              dataType: 'json',
              async: false,
              success: function() {
              },
              error:function(response) {
              }
          });
        }
        $("#AddToCart").trigger('click');
        
      } else {
        alert('Please add all the selected fields');
      }

       /*const tabContents = document.querySelectorAll('.gravuroptions .tab-contents .tab-content');

      tabContents.forEach(function (tabContent) {
        const gravurartItems = tabContent.querySelectorAll('.gravurart-items');

        gravurartItems.forEach(function (item) {
          if (item.classList.contains('active')) {
            const propertyName = item.getAttribute('data-property-name');
            const dataType = item.getAttribute('data-type');

            console.log('Property Name:', propertyName);
            console.log('Data Type:', dataType);
          }
        });
      // Trigger the form submission
      //$('form.shopify-product-form').submit();
    });*/
  }

 /* document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll(".tab-contents .tab-content").forEach(function(tabContent) {
            // Find the first <ul> with class 'gravurart' inside each tab-content
            var ulElement = tabContent.querySelector("ul.gravurart");
         if (ulElement) {
                // Find the first <li> inside the ul.gravurart
                var firstLi = ulElement.querySelector("li");
                if (firstLi) { 
                    
                    firstLi.click(); // Trigger click event
                }
            }
      });
  });*/
function handleToggle(toggle) {
   if ($(".gravuroptions").length) {
        var margin = 20;  // Adjust the margin as needed
        var bodyOffset = $("body").offset().top;  // Get the body offset
        var targetOffset = $(".gravuroptions").offset().top;  // Get the target offset
        
        // Calculate the scroll position relative to the body
        var scrollPosition = targetOffset - bodyOffset - margin;
        
        //$("html, body").animate({
        //    scrollTop: $(".gravuroptions").offset().top + scrollPosition
       // }, "slow");
    }

  let wrapper = document.getElementById("product_gravur__Wrapper");
    let target = document.querySelector(".gravuroptions");
    
    if (wrapper && target) {
        console.log('found');
        wrapper.scrollTo({
            top: target.offsetTop - wrapper.offsetTop,
            behavior: "smooth"
        });
    } else {
      console.log('not found');
    }
  
    if (toggle.checked) {
       //preselected_options();
      //console.log('checked');
      var openConfigurator = function () {
        if (!toggle.checked) return;
        const statusElement = document.getElementById('toggle-status');
        const gravuroptions = document.querySelectorAll('.gravuroptions');
        gravuroptions.forEach(function (option) {
            option.style.display = "block";
        });
        document.querySelectorAll(".tab-contents .tab-content ul.gravurart li").forEach(function(li) {
          if (li.classList.contains("no-gravur")) {
              li.click();
          }
        });
      };
      if (window.GravurDeferred && typeof window.GravurDeferred.ensure === 'function') {
        window.GravurDeferred.ensure().then(openConfigurator);
      } else {
        openConfigurator();
      }
    } else {
      $(".default_product_id").each(function(){
        var pid = $(this).val();
        $(".first-step-button-"+pid).css('display','none');
      })
      $(".all_total_values_count").val(0);
      $(".all_total_values_count").attr('data-stepone-count',0);
      $(".items").removeClass('active');
      $(".tab-items").removeClass('active');
      $(".motivelist").css('display','none');
      $('.motivelist input[type="file"].file_upload').val('');
      $('.motivelist input[type="text"]').val('');
      $('.motivelist textarea.motive_text').val('');
      $(".tab-content").each(function(index){
        if (index == 0) {
          $(this).css('display','block');
        } else {
          $(this).css('display','none');
        }
      })
      $(".parent-tab-content").css('display','none');
      var counter = 1;
      $(".tab-item").each(function(){
        if (counter == 1) {
          $(this).addClass('active');
        } else {
          $(this).removeClass('active');
        }
        $(".gravurart-"+counter).addClass('active');
        $("#tab-content-gravurart-"+counter).css('display','block');
        counter++;
      })
      
      const gravuroptions = document.querySelectorAll('.gravuroptions');
      gravuroptions.forEach(function (option) {
          option.style.display = "none";
      });
     
    }  
}

// document.addEventListener("keydown", function (event) {
//     if (event.key === "Enter") {
//         event.preventDefault();
//     }
// });

document.addEventListener("keydown", function (e) {
  if (e.key === 'Enter') {
    const target = e.target;

    // If it's a textarea with specific classes, prevent default
    if (target.classList.contains('motive_text') && target.classList.contains('initialen')) {
      e.preventDefault();
    }
    // Or if it's not a textarea at all, also prevent default
    else if (target.tagName !== 'TEXTAREA') {
      //e.preventDefault();
    }
  }
});

const lineTracker = new WeakMap();

document.addEventListener('input', function (e) {
  if (e.target.tagName === 'TEXTAREA' && e.target.classList.contains('auto-expand')) {
    const el = e.target;

    const lineCount = el.value.split('\n').length;
    const previous = lineTracker.get(el) || 1;
    //console.log('lineCount---'+lineCount);
    if(lineCount == '1') {
       el.style.height = 67 + 'px'; 
    } else if (lineCount !== previous) {
      el.style.height = 'auto';
      el.style.height = el.scrollHeight - 30 + 'px';
      lineTracker.set(el, lineCount);
    } 
  }
});

function initAutoExpandTextareas() {
  document.querySelectorAll('textarea.auto-expand').forEach(el => {
    el.style.height = el.scrollHeight + 'px';
    lineTracker.set(el, el.value.split('\n').length);
  });
}

initAutoExpandTextareas();
document.addEventListener('gravur:panels-ready', initAutoExpandTextareas); 

document.addEventListener("DOMContentLoaded", function() {
  // Select all <a> elements with classes 'step-completed final-step'
  document.querySelectorAll("a.step-completed.final-step").forEach(function(element) {
    element.addEventListener("click", function(event) {
      event.preventDefault(); // Prevent default action if needed
      this.classList.add("active"); // Add 'active' class on click
    });
  });
});

$(document).ready(function() {
  $(document).on('click', "#floatingSection .faq .faq__wrapper .faq__item button.collapsible-toggle", function (event) {
    event.preventDefault(); // Prevent default behavior (useful if it's a link or submit button)
    
     
});

  /*$("#floatingSection .faq .faq__wrapper .faq__item button.collapsible-toggle").click(function(event) {
      alert('click herer');
      console.log('retutn flal');
      return false;
        event.preventDefault(); 
    });*/
});

document.addEventListener("DOMContentLoaded", function () {
    if (typeof jQuery !== 'undefined') {
      jQuery(".header__linklist-item").hover(function () {
        jQuery(".child-menu").removeClass("show");
        jQuery(".left_second_lvl").removeClass("left_bold");
        jQuery(this).find(".child-menu:first").addClass("show");
        jQuery(this).find(".left_second_lvl:first").addClass("left_bold");
      });
      jQuery(".parent-link > a").hover(function () {
        jQuery(".child-menu").removeClass("show");
        jQuery(".left_second_lvl").removeClass("left_bold");
        jQuery(this).next(".child-menu:first").addClass("show");
        jQuery(this).addClass("left_bold");
      });
      jQuery(".right_side_whol_link, .child-menu").hover(
        function () {
          jQuery(this).closest(".parent-link").addClass("bold");
        },
        function () {
          if (!jQuery(".child-menu:hover, .right_side_whol_link:hover").length) {
            jQuery(this).closest(".parent-link").removeClass("bold");
          }
        }
      );
      jQuery(".right_side_whol_link .linklist__item .third_level_sub_link").hover(
        function () {
          jQuery(this).closest(".right_side_whol_link > .linklist__item").addClass("bold");
        },
        function () {
          jQuery(this).closest(".right_side_whol_link > .linklist__item").removeClass("bold");
        }
      );
      jQuery(".third_level_sub_link > .linklist__item").hover(function () {
        jQuery(this).toggleClass("bold");
      });
    }

    // Click outside to close
    document.addEventListener("click", function (event) {
        // 09/2026: Klicks auf die Info-Schaltflaeche ("Bild Anforderungen - So
        // geht's richtig") duerfen das Fenster nicht schliessen. Sie liegt
        // ausserhalb des Fensters, wurde von diesem Waechter also als
        // "Klick daneben" gewertet - das Fenster ging auf und sofort wieder zu.
        // Frueher lief der oeffnende Code direkt in der Seite und war vor
        // diesem Waechter registriert; seit er in product-gravurarten.js mit
        // defer ausgelagert ist, hat sich die Reihenfolge umgedreht.
        if (event.target.closest && event.target.closest(".info_col")) {
            return;
        }
        let isClickInside = false;
    // Get all floating sections
        const floatingSections = document.querySelectorAll(".floating-section");

        floatingSections.forEach(floatingSection => {
            // Check if the current floating section is active
            if (floatingSection.classList.contains("active")) {
                if (floatingSection.contains(event.target)) {
                    isClickInside = true;
                }
            }
        });

        if (!isClickInside) {
            floatingSections.forEach(floatingSection => {
                floatingSection.classList.remove("active");
            });
            document.body.classList.remove("floating-active");
        }
    });

    document.querySelectorAll(".mobile-nav__link").forEach((menuLink) => {
      menuLink.addEventListener("click", function () {
        let menuHandle = this.getAttribute("data-menu");
        let menuContent = document.querySelector(`.sidebar-menu__parent-category[data-menu-content="${menuHandle}"]`);
        document.querySelectorAll(".sidebar-menu__parent-category").forEach((menu) => {
          if (menu !== menuContent) {
            menu.classList.remove("show");
            menu.querySelectorAll(".dropdown-toggle-btn svg").forEach((icon) => icon.classList.remove("rotate"));
          }
        });
        if (menuContent) {
          menuContent.classList.toggle("show");
          let icon = this.querySelector("svg");
          if (icon) icon.classList.toggle("rotate");
        }
      });
    });
    document.querySelectorAll(".dropdown-toggle-btn").forEach((button) => {
      button.addEventListener("click", function (event) {
        event.stopPropagation();
        let submenu = this.nextElementSibling;
        let icon = this.querySelector("svg");
        if (!submenu) return;
        let parentMenu = this.closest("ul");
        if (parentMenu) {
          parentMenu.querySelectorAll(".submenu, .third-level-links").forEach((menu) => {
            if (menu !== submenu) {
              menu.classList.remove("show");
              const prev = menu.previousElementSibling;
              if (prev) {
                const prevIcon = prev.querySelector("svg");
                if (prevIcon) prevIcon.classList.remove("rotate");
              }
            }
          });
        }
        submenu.classList.toggle("show");
        if (icon) icon.classList.toggle("rotate");
      });
    });
});
